"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Osnsocial;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Osnsocial(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Brands",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "osnsocial"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M90,31.836H71.651L76.091,13.5a2.5,2.5,0,0,0-4.86-1.178l-4.725,19.51h-2.6l2.956-12.274a1.5,1.5,0,1,0-2.916-.7L60.823,31.836H44.547L48.986,13.5a2.5,2.5,0,1,0-4.859-1.178L39.4,31.836H36.719l2.957-12.274a1.5,1.5,0,0,0-2.916-.7L33.634,31.836H20.054a2.5,2.5,0,0,0,0,5H38.191l-5.353,22.1h-2.8L34.291,41.36a1.5,1.5,0,0,0-1.458-1.852H14.2a1.5,1.5,0,0,0,0,3H30.928L26.957,58.939H13.278a2.5,2.5,0,1,0,0,5H31.627l-4.44,18.333a2.5,2.5,0,1,0,4.86,1.178l4.725-19.511H58.731l-4.44,18.333A2.5,2.5,0,1,0,59.15,83.45l4.726-19.511H83.224a2.5,2.5,0,0,0,0-5H65.087l5.353-22.1H90a2.5,2.5,0,0,0,0-5Zm-30.058,27.1h-2.71L61.48,41.36a1.5,1.5,0,0,0-1.458-1.852H50.678a1.5,1.5,0,0,0,0,3h7.439L54.146,58.939H37.983l5.353-22.1H65.3Zm-5.069,9.525L50.287,87.437a1.5,1.5,0,0,1-1.457,1.148,1.533,1.533,0,0,1-.353-.042,1.5,1.5,0,0,1-1.106-1.811L51.51,69.611H44.069a1.5,1.5,0,0,1,0-3h9.346a1.5,1.5,0,0,1,1.458,1.853Zm-27.189,0L23.1,87.437a1.5,1.5,0,0,1-1.457,1.148,1.535,1.535,0,0,1-.354-.042,1.5,1.5,0,0,1-1.105-1.811L24.32,69.611H7.6a1.5,1.5,0,0,1,0-3h18.63a1.5,1.5,0,0,1,1.458,1.853ZM76.157,39.508a1.5,1.5,0,0,1,0,3H72.1a1.5,1.5,0,0,1,0-3Zm-5.107,28.6a1.5,1.5,0,0,1-1.5,1.5H66.812a1.5,1.5,0,0,1,0-3H69.55A1.5,1.5,0,0,1,71.05,68.111Z"
  })));
}